import { Pipe, PipeTransform } from '@angular/core';
import { Ticket } from '../interfaces/ticket';

@Pipe({
  name: 'filterTickets'
})
export class FilterTicketsPipe implements PipeTransform {

  transform(tickets: Ticket[]): Ticket[] {
    return tickets?.filter((ticket: Ticket) => !ticket.fakeTicket);
  }

}
